export enum TripEventType {
  NotSet = 0,
  Begin = 1,
  Finish = 2,
  ChangeCountry = 3,
  TripExclusionStart = 4,
  TripExclusionEnd = 5,
  Arrive = 6,
  Leave = 7,
  Loading = 8,
  Unloading = 9,
}
